import { fetchWithAuth } from '@shared/utils/auth';
import { backendUrl } from '@shared/constants/urls/appUrls';

const GIFS_URL = `${backendUrl}/api/comments/gifs/`;
const DEFAULT_LIMIT = 20;

//------------------------------------------------------------------------------
//                        Запрос гифок через свой бэкенд
//------------------------------------------------------------------------------
// Ключ Giphy живет только на бэкенде: у провайдера жесткий лимит запросов,
// поэтому фронт ходит через прокси с кэшем
const toFetchGifs = async (params) => {
  const url = `${GIFS_URL}?${new URLSearchParams(params)}`;
  const response = await fetchWithAuth(url, { method: 'GET' });
  if (!response.ok) {
    throw new Error(`Ошибка запроса гифок: HTTP error! Status: ${ response.status }`);
  }
  const data = await response.json();
  return data.results;
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx


//------------------------------------------------------------------------------
//                            Поиск гифки
//------------------------------------------------------------------------------
export const searchGifs = async (query, limit = DEFAULT_LIMIT) => {
  try {
    return await toFetchGifs({ q: query, limit: limit.toString() });
  } catch (error) {
    console.error('Программная ошибка поиска гифок: Error fetching gifs:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx


//------------------------------------------------------------------------------
//                            Трендовые гифки
//------------------------------------------------------------------------------
export const getTrendingGifs = async (limit = DEFAULT_LIMIT) => {
  try {
    return await toFetchGifs({ limit: limit.toString() });
  } catch (error) {
    console.error('Ошибка получения трендов GIF:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
